// extracted by mini-css-extract-plugin
export var colorSquare = "_o1-0";
export var danger = "_o1-5";
export var lightPink = "_o1-8";
export var neutralBlue = "_o1-7";
export var neutralYellow = "_o1-6";
export var normal = "_o1-1";
export var primary = "_o1-2";
export var primaryLight = "_o1-3";
export var solidBlack = "_o1-g";
export var solidGreen = "_o1-b";
export var solidLightBlue = "_o1-d";
export var solidNavy = "_o1-c";
export var solidOrange = "_o1-f";
export var solidPink = "_o1-e";
export var solidRed = "_o1-9";
export var solidYellow = "_o1-a";
export var success = "_o1-4";